module.exports = __webpack_public_path__ + "img/fenji-icon.a0c8b8d7.png";